export const skuUsageLabels = {
    PURCHASE: '采购物料（只采购）',
    SALE: '销售产品（只销售）',
    BOTH: '购销两用',
    INTERNAL: '内部物料（不对外交易）',
};
export function canUseSku(usage, side) {
    return usage === 'BOTH' || usage === (side === 'BUY' ? 'PURCHASE' : 'SALE');
}
